/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TGenericBlueprintSchema } from "../../Schema/IBlueprintSchema";
import { ISchemaConstArrayOpts, SchemaConstArray, ISchemaConstArray } from "../const/SchemaConstArray";
import { ISchemaValue, ISchemaValueOpts, SchemaValue } from "./SchemaValue";

export interface ISchemaValueArrayOpts<
	TItemsSchema extends TGenericBlueprintSchema
> extends ISchemaValueOpts<ISchemaConstArray<TItemsSchema>>, ISchemaConstArrayOpts<TItemsSchema> {}

/**
 * Schema: Array value
 *
 * @param opts Schema options
 */
export function SchemaValueArray<
	TItemsSchema extends TGenericBlueprintSchema
>(opts: ISchemaValueArrayOpts<TItemsSchema>): ISchemaValue<ISchemaConstArray<TItemsSchema>> {

	return SchemaValue(SchemaConstArray(opts), opts);

}
